// =============================================================================
// PrimaryButton — pulsante principale del flusso pubblico, usa il colore brand
// =============================================================================

import { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export function PrimaryButton({ children, className = '', style, ...rest }: Props) {
  return (
    <button
      {...rest}
      className={`px-5 py-2.5 rounded-lg text-sm font-semibold text-white inline-flex items-center gap-2 shadow-sm transition-all hover:opacity-95 hover:shadow-md active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none ${className}`}
      style={{ background: 'var(--skedulab-public-primary, #10B981)', ...style }}
    >
      {children}
    </button>
  );
}
